import { render, staticRenderFns } from "./up-report.vue?vue&type=template&id=c4a9de52&scoped=true"
import script from "./up-report.vue?vue&type=script&lang=js"
export * from "./up-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a9de52",
  null
  
)

export default component.exports